import React from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import WrapperWithTabs from "../../components/WrapperWithTabs";
import { tabBarOptions } from "./tabBarOptions";
import CustomButton from "../../components/CustomButton";
import { icons } from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const Vouchers = () => {
  const navigate = useNavigate();
  const onClickSubmitVouchers = () => {
    navigate("/vouchers/submit", {state: {isEditFeatureOn: false}});
  };
  const {
    user: { userLabel },
    currentTabSelect
  } = useAuth();

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Vouchers"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          if (userLabel === "Store")
            return (
              <CustomButton
                title="Submit Voucher"
                icon={icons.plusIcon}
                onClick={onClickSubmitVouchers}
              />
            );
        }}
      />
      <WrapperWithTabs
        tabBarOptions={tabBarOptions}
        commonProps={{ title: "Hi" }}
        componentBasedProps={{ 1: { subTitle: "Hello" } }}
        wrapperClassName="mt-12"
        tabSelected={currentTabSelect.id ? currentTabSelect : null}
      />
    </div>
  );
};

export default Vouchers;
